<template>
  <div class="content-nodata">
    <img
      data-testid="uc-empty-list-img"
      height="40"
      width="40"
      :src="icon"
      @click="emit('click-icon')"
    >
    <p>
      <strong data-testid="uc-empty-list-title">{{ title }}</strong><br>
      <span data-testid="uc-empty-list-subtitle">{{ subtitle }}</span>
    </p>
  </div>
</template>

<script setup>
// @ts-check
import defaultIcon from '@/static/img/ic_add_farm.svg';

defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: defaultIcon,
  },
});

const emit = defineEmits(['click-icon']);
</script>

<style scoped lang="scss">
.content-nodata {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin-top: 15vh;

  div {
    max-width: 195px;
  }

  &__title {
    color: var(--his-darkgray);
    font-weight: 500;
    font-size: 18px;
  }

  &__text {
    color: var(--his-ash-gray);
    font-size: 14px;
    font-weight: 300;
    margin-top: 10px;
  }
}
</style>
